import React from 'react';
import '../../styles/enterprise.css';

/**
 * Wraps a row of <KpiCard /> children. Responsive: 4 cols -> 2 -> 1.
 *
 * <KpiStrip>
 *   <KpiCard ... />
 *   <KpiCard ... />
 * </KpiStrip>
 */
const KpiStrip = ({ children, className = '' }) => (
  <div className={`kpi-strip ${className}`.trim()}>{children}</div>
);

export default KpiStrip;
